<div class="c-navbar">
  <img src="../../../assets/logo_negativa.svg" alt="" />
</div>
<div class="c-hero" [ngClass]="classRed ? 'red-bg' : ''">
  <div class="c-hero__content">
    <h1>Parabéns!</h1>
    <p>Você está prestes a se tornar membro <b>Black</b> do Madero Cashback</p>
    <button
      mat-flat-button
      class="c-btn c-btn--primary lg"
      (click)="scrollToBotton()"
    >
      Faça parte!
    </button>
  </div>
  <div class="c-hero__content">
    <img src="../../../assets/cards.png" class="floating" alt="" />
  </div>
</div>
<div class="c-partner">
  <img src="../../../assets/madero-partner.svg" alt="" />
  <h1>e</h1>
  @if (imagePartner) {
  <img [src]="imagePartner" alt="" />
  }
</div>
<div class="c-partner-description">
  <div class="c-partner-description__content">
    <img src="../../../assets/hand-phone.png" alt="" />
  </div>
  <div class="c-partner-description__content">
    <p>
      Ao se cadastrar por meio desta página, você se tornará <b>Madero Cashback Black.</b>
    </p>
    <p>
      Com isso, você acumulará até <b>10%</b> de cashback em cada compra 
      realizada nos <b>nossos restaurantes ou APP</b>, que poderá ser utilizado 
      nas suas próximas refeições, para acompanhar e resgatar seu saldo de 
      cashback, baixe o App Grupo Madero.
    </p>
  </div>
</div>
<div class="c-steps">
  <h1>COMO FUNCIONA?</h1>
  <p>
    O Madero Cashback é um programa de fidelidade que fornece créditos retornáveis 
    para consumo nos restaurantes Madero, Jeronimo, Madero & Jeronimo e Ecoparada. 
    Eles são acumulados durante uma ou mais visitas nos restaurantes participantes e, 
    quando resgatados, podem ser utilizados como desconto sobre o valor total na sua próxima consumação.
  </p>
  <h1 class="c-steps__sub">Veja como é fácil participar:</h1>
  <div class="c-steps__steps">
    <div class="c-steps__steps--item">
      <img src="../../../assets/step/step1.png" alt="" />
      <h1>CADASTRE-SE</h1>
      <p>
        Preencha o formulário abaixo para fazer parte do Madero Cashback,
      </p>
    </div>
    <div class="c-steps__steps--item">
      <img src="../../../assets/step/step2.png" alt="" />
      <h1>ACUMULE</h1>
      <p>
        Após preencher a LP, você já é Madero Cashback e começa acumular créditos retornáveis 
        consumindo em qualquer um dos restaurantes participantes informando seu CPF.
      </p>
    </div>
    <div class="c-steps__steps--item">
      <img src="../../../assets/step/step3.png" alt="" />
      <h1>TROQUE</h1>
      <p>
        Para consultar seu saldo, baixe o App Grupo Madero, verifique se saldo de créditos e 
        resgate para aplicar o desconto na sua próxima compra.
      </p>
    </div>
  </div>
</div>
<div class="c-footer">
  <div class="c-footer__item">
    <h1>Preencha suas informações para continuar</h1>
    <app-registration-form
      [partnerActive]="partnerActive"
      [binActive]="binActive"
      [hasBackground]="false"
    >
    </app-registration-form>
  </div>
  <div class="c-footer__item dark">
    <div class="c-flex">
      <img src="../../../assets/footer-logo.png" alt="" />
      <h4>Baixe o app e aproveite suas vantagens</h4>
      <div class="c-stores">
        <div class="c-stores__item" (click)="onRedirect('apple')">
          <img src="../../../assets/store-apple.png" class="c-cursor" alt="" />
        </div>
        <div class="c-stores__item" (click)="onRedirect('google')">
          <img src="../../../assets/store-google.png" class="c-cursor" alt="" />
        </div>
      </div>
    </div>
  </div>
</div>
